// import { CommonData } from "../../../datastructures/gamestate/gameData";
import { CommonData } from "../../../datastructures/gamestate/gameData";
import { recoverGameBar } from "../../../functions/Functions_GameBar";
import { replaceUnderscoresWithSpaces } from "../../../functions/Functions_General";
// import { PopupMessageBox } from "../../../messageBox";
import {
  GamePlayResult,
  GamePlayResultsList,
} from "../../APIModels/gamePlayResult";
import { JackpotContext } from "../../APIModels/jackpotContext";
import {
  GameContext,
  GameRoundMetaData,
  PlayerBalance,
} from "../../APIModels/models";
import { EmulationToggleBtn } from "./emulationBtns";
import { EmulationSelectorList } from "./emulationSelector";
export class EmulationMain {
  private emulationDataHandler: EmulationModeDataHandler;
  private emulationUserInterface: EmulationInterfaceHandler;
  private activeFeatureIndex: number = 0;
  public selectioneIndex: number;
  private parent = new PIXI.Container();
  private activeGameData: CommonData;
  private featuresListData: GameRoundMetaData[];
  private defaultSelected: boolean = false;
  private isInLandscape: boolean = true;
  private textActiveOverlay: PIXI.Text;
  private textActiveOverlayTween: PIXI.tween.Tween;
  private isVisible: boolean = false;
  private disableInitalSpin: boolean = true;
  constructor(parent: PIXI.Container, activeGameData: CommonData) {
    parent.addChild(this.parent);
    this.parent.alpha = 0;
    this.activeGameData = activeGameData;
    //--define the default calss
    this.emulationDataHandler = new EmulationModeDataHandler();
    this.emulationUserInterface = new EmulationInterfaceHandler(
      this.parent,
      this.activeGameData
    );
    //--add error message--
    this.setGameActiveText();
    //--
    this.toggleEmulationMenu();
  }
  public setGameActiveText = (): void => {
    const style = new PIXI.TextStyle({
      fill: "#ffffff",
      fontFamily: "Tahoma",
      fontSize: 50,
      fontWeight: "bold",
      lineJoin: "round",
      strokeThickness: 7,
    });
    this.textActiveOverlay = new PIXI.Text("Game is active.", style);
    this.parent.addChild(this.textActiveOverlay);
    this.textActiveOverlay.anchor.set(0.5);
    this.textActiveOverlay.x = this.activeGameData.size[0] / 2;
    this.textActiveOverlay.y = this.activeGameData.size[1] / 2;
    //--create rtween
    this.textActiveOverlay.alpha = 0;
    this.textActiveOverlayTween = PIXI.tweenManager.createTween(
      this.textActiveOverlay
    );
    this.textActiveOverlayTween.from({ alpha: 0 }).to({ alpha: 1 });
    this.textActiveOverlayTween.time = 1500; //330 ease in defalut
    this.textActiveOverlayTween.loop = false;
    this.textActiveOverlayTween.pingPong = true;
    this.textActiveOverlayTween.repeat = 1;
    this.textActiveOverlayTween.easing = PIXI.tween.Easing.outExpo();
    this.textActiveOverlayTween.stop();
  };
  private setGameIsActiveTextLandscape = (bool: boolean): void => {
    if (bool) {
      this.textActiveOverlay.x = this.activeGameData.size[0] / 2;
      this.textActiveOverlay.y = this.activeGameData.size[1] / 4;
      // this.textActiveOverlay.scale.set(0.5);
    } else {
      this.textActiveOverlay.x = this.activeGameData.size[0] / 4.7;
      this.textActiveOverlay.y = 0;
      // this.textActiveOverlay.scale.set(0.5);
    }
  };
  private setVisibleGameActiveText = (): void => {
    this.textActiveOverlay.alpha = 0;
    this.textActiveOverlayTween.stop();
    this.textActiveOverlayTween.reset();
    this.textActiveOverlayTween.start();
  };
  public open = (): void => {
    this.getAllFeaturesList();
    //-
    // check if game isRecovered
    if (this.activeGameData?.loginResponse?.activeGame) {
      this.setGameReoveredText();
    }
  };

  public closeEmulationMenuExpand = (): void => {
    this.emulationUserInterface.setVisible(false);
    this.isVisible = false;
  };
  public toggleEmulationMenu = (): void => {
    if (this.activeGameData.replayMode) {
      //disable all interactions with the  emulation if replay is active
      this.closeEmulationMenuExpand();
      return;
    } else {
      let toggle = this.emulationUserInterface.getVisible();
      this.emulationUserInterface.setVisible(!toggle);
      this.isVisible = !toggle;
      // console.log("IS MAIN INTERFACE VISIBLE", !toggle);
    }
  };
  public getISVisible = (): boolean => {
    return this.isVisible;
  };
  public enableClickOnFeatureSelect = (bool: boolean): void => {
    //use to control the emulation feature selection on or off per game

    // this.emulationUserInterface.enableBtns(bool);// dont need anuymore
    this.emulationUserInterface.setMainToggleRed(bool);
  };
  public getAllFeaturesList = (): void => {
    this.activeGameData.API_handler.GetAllEmulationsResult(
      this.loadAllFeaturesSucccess,
      this.activeGameData.betFail
    );
  };

  private clearPreciousGame = (): void => {
    if (this.activeGameData.jackPotGame.isJackpotOpen()) {
      this.activeGameData.jackPotGame.stop();
    }
    // console.log("preClear")
    this.activeGameData.clearOnReplayOpenClose(); //call the game replay function
    // recoverGameBar(this.activeGameData); //update the game bet amount
    // this.testClear();
  };

  public selectFeatureByIndex = (index: number): void => {
    if (
      this.activeGameData?.betResponse?.gameContext?.contextData?.finished ==
      false
    ) {
      this.disableInitalSpin = false;
      // console.log('rounds still active');
      this.setVisibleGameActiveText();
      return;
    }
    this.SetWaitingServerResponse(true); //
    this.clearPreciousGame();
    this.selectioneIndex = index;
    //index is index of btn  , need to use it as index for game id;
    let featureid = this.featuresListData[index].id;
    this.activeFeatureIndex = featureid;
    this.activeGameData.API_handler.setactiveRoundID(this.activeFeatureIndex);
    this.activeGameData.API_handler.SetEmulationGameRound(
      this.featureSelectRequested,
      this.activeGameData.betFail
    );
  };

  public setGameReoveredText = (): void => {
    this.emulationUserInterface.setInstructionText(
      this.activeGameData.gameTextGeneral.gameRecovered
    );
    //colse the emulation selection screen;
    this.toggleEmulationMenu(); //collapse the expanded
  };

  private SetWaitingServerResponse = (bool: boolean) => {
    this.emulationUserInterface.isWaitinServerResponse(bool);
    console.log("waiting for server response :", bool);
  };
  private featureSelectRequested = (): void => {
    this.SetWaitingServerResponse(false); //
    this.parent.alpha = 1;
    this.setLandScapeMode(this.isInLandscape);
    // console.log('emulation Game Round Requested successfully');
    // request bet

    this.onSelectFeatureStart(); //
    this.toggleEmulationMenu(); //close the emulation menu screen
    //---update the selected feature
    let roundId = this.featuresListData[this.selectioneIndex].id;
    let gameRoundName = replaceUnderscoresWithSpaces(
      this.featuresListData[this.selectioneIndex].featureName
    );
    this.emulationUserInterface.setInstructionText(
      roundId + ": " + gameRoundName
    );
  };

  //--loading all list of game rounds

  private noFeatureAvailable = (): void => {
    //create error message box
    this.activeGameData.betFail("networkErrorBody");
    this.activeGameData.errorBox.setBodyText(
      this.activeGameData.gameTextGeneral.emulationDontExist
    );
  };
  private loadAllFeaturesSucccess = (
    featuresListData: GameRoundMetaData[]
  ): void => {
    if (featuresListData.length == 0) {
      this.noFeatureAvailable();
      return;
    }
    this.featuresListData = featuresListData;
    this.emulationUserInterface.createEmulationFeaturesList(
      this.featuresListData
    );
    this.parent.alpha = 1;
    this.setLandScapeMode(this.isInLandscape);
    //-- select first feature
    if (
      featuresListData.length > 0 &&
      !this.activeGameData?.loginResponse?.activeGame
    ) {
      this.selectFeatureByIndex(0);
    }
  };
  //--loading specific list of game rounds
  private onSelectFeatureStart = (): void => {
    if (this.disableInitalSpin) {
      //autoload the first spin but dont spin
      this.toggleEmulationMenu(); //collapse the expanded
      this.disableInitalSpin = false;
      return;
    } else {
      this.emulationUserInterface.hideTheInstructions(true);
      if (this.activeGameData.isTableGame) {
        //needs to laod chips on table
        this.instantReload();
      } else {
        //dont need to display the winlines instantly
        this.slowReloadWithSpin();
      }
    }
  };

  private slowReloadWithSpin = (): void => {
    // console.log("postClear")
    this.activeGameData.clearOnReplayOpenClose();
    // console.log(this.activeGameData.betResponse);
    this.activeGameData.replayFn(); //call the game replay function;

    recoverGameBar(this.activeGameData); //update the game bet amount
  };
  private instantReload = (): void => {
    this.activeGameData.clearOnReplayOpenClose();
    this.activeGameData.reloadGame = true;
    this.activeGameData.displayReplayMsg = false;
    this.activeGameData.recoverSuccess(this.activeGameData.betResponse);
  };

  public loadFeatureSuccess = (gameRoundData: GamePlayResultsList): void => {
    //load fake jackpot contetx

    this.emulationDataHandler.setGameRounds(gameRoundData);
    if (this.defaultSelected) {
      this.onSelectFeatureStart(); //
      this.toggleEmulationMenu(); //close the emulation menu screen
    } else {
      this.defaultSelected = true;
      //-it is to allow game to select the index 0 by default from the game rounds as game data  so when player dont select it will still works and play the game round at the index zerp
    }

    let roundId = this.featuresListData[this.selectioneIndex].id;
    let gameRoundName = replaceUnderscoresWithSpaces(
      this.featuresListData[this.selectioneIndex].featureName
    );
    this.emulationUserInterface.setInstructionText(
      roundId + ": " + gameRoundName
    );
    //copy jackpot data at the begining

    this.activeGameData.betResponse.jackpotContext =
      gameRoundData.jackpotContext;
    // this.activeGameData.jackPotGame.emulationJackpotRandomValue();
  };
  public loadNext = (): GamePlayResult => {
    let newData = this.emulationDataHandler.getNext();
    this.activeGameData.betResponse = newData;
    // this.clearAfterGettingRoundData();
    // this.activeGameData.clearOnReplayOpenClose();
    return newData;
  };
  public setLandScapeMode = (bool: boolean): void => {
    this.isInLandscape = bool;
    // console.log(' LOAD LANDSCAPE', bool);
    this.parent.scale.set(bool ? 1 : 2.4);
    this.emulationUserInterface.setLandScape(bool);
    // console.log('--', this.parent.scale.x,this.parent.scale.y)

    this.setGameIsActiveTextLandscape(bool);
  };
  public isStartOfRound = (): boolean => {
    let isStart = this.emulationDataHandler.getCurrentIndex() == 0;
    return isStart;
  };
}

class EmulationInterfaceHandler {
  private parent = new PIXI.Container();
  private parentFeatureListOpen = new PIXI.Container();
  private parentFeatureListClosed = new PIXI.Container();
  private listFeatureParent = new PIXI.Container();
  private activeGameData: CommonData;
  private gameFeaturesList: GameRoundMetaData[];
  private featureSelectBtns: EmulationSelectorList;
  private bgListOpen: PIXI.Graphics;
  private bgListClosed: PIXI.Graphics;
  private closeBtn: EmulationToggleBtn;
  private FeatureSelectedText: PIXI.Text;
  private instructionText: PIXI.Text;
  constructor(parent: PIXI.Container, activeGameData: CommonData) {
    this.activeGameData = activeGameData;
    parent.addChild(this.parent);
    this.parent.addChild(this.parentFeatureListOpen);
    this.parent.addChild(this.parentFeatureListClosed);
    this.parentFeatureListOpen.addChild(this.listFeatureParent);

    // /---
    this.createBgFortheFeatureList();

    this.createSelectedFeatureText();
    this.createInstructionsText();
    this.createToggleBtn();
    // this.activeGameData.emulationMode.toggleEmulationMenu();

    this.setVisible(false); //default set invisible
  }
  private createInstructionsText = (): void => {
    const style = new PIXI.TextStyle({
      fill: "#ffffff",
      fontFamily: "Tahoma",
      fontSize: 35,
      lineJoin: "round",
      miterLimit: 5,
    });

    this.instructionText = new PIXI.Text(
      "Select a feature to start emulation.",
      style
    );
    this.instructionText.anchor.set(0.5, 0.5);
    this.instructionText.x =
      this.bgListOpen.width / 2 + this.bgListClosed.width / 2;
    this.instructionText.y = 50;
    this.activeGameData.size[1] - 100;
    // this.instructionText.rotation = -(Math.PI / 2);
    this.parent.addChild(this.instructionText);
  };
  public hideTheInstructions = (bool: boolean): void => {
    this.instructionText.alpha = bool === true ? 0 : 1;
  };
  public isWaitinServerResponse = (bool: boolean): void => {
    this.featureSelectBtns.setIsWatingResponse(bool);
  };
  public setLandScape = (bool: boolean): void => {
    if (bool) {
      //landscape //snap the interface to right of the screen
      this.bgListOpen.height = this.activeGameData.size[1];
      this.bgListOpen.y = 0;
      this.bgListClosed.height = this.activeGameData.size[1];
      this.bgListClosed.y = this.bgListOpen.y;
      let canvas = document.getElementsByTagName("canvas")[0];
      let moveX = 0;
      let canvasWidth = canvas.width / this.activeGameData.gameScene.scale.x;
      if (canvasWidth > this.activeGameData.size[0]) {
        moveX = (canvasWidth - this.activeGameData.size[0]) * -1;
        // console.log(canvasWidth,canvas.width,moveX,this.activeGameData.ratioScaleX)
      }

      this.parent.x = moveX / 2;
    } else {
      //portrait;
      let canvas = document.getElementsByTagName("canvas")[0];
      this.bgListClosed.height = canvas.height + this.activeGameData.size[1];
      this.bgListOpen.height = this.bgListClosed.height;
      this.bgListOpen.y = -this.activeGameData.size[1];
      this.bgListClosed.y = this.bgListOpen.y;
      this.parent.x = 0;
    }
    // if(  this.featureSelectBtns!=undefined)
    // {
    // this.featureSelectBtns.setLandscapeMode(bool);
    // }
  };
  private createBgFortheFeatureList = (): void => {
    this.bgListOpen = new PIXI.Graphics()
      .beginFill(0x121212, 0.85)
      .drawRoundedRect(0, 0, 800, this.activeGameData.size[1], 0)
      .endFill();
    this.bgListOpen.interactive = true;
    this.listFeatureParent.addChild(this.bgListOpen);

    this.bgListClosed = new PIXI.Graphics()
      .beginFill(0x7b0e35, 0.85)
      .drawRoundedRect(0, 0, 75, this.activeGameData.size[1], 0)
      .endFill();
    this.parentFeatureListClosed.addChild(this.bgListClosed);
    this.bgListClosed.interactive = true;
    this.bgListClosed.buttonMode = true;
    this.bgListClosed.on("pointertap", this.onMenuClick);
  };
  private onMenuClick = (): void => {
    this.activeGameData.emulationMode.toggleEmulationMenu();
  };
  private createToggleBtn = (): void => {
    //create toggle btn

    this.closeBtn = new EmulationToggleBtn(
      this.listFeatureParent,
      this.activeGameData
    );
    this.closeBtn.setPositionMenu(135, 100);
    this.closeBtn.setPositionClose(135, this.activeGameData.size[1] - 150);
  };
  private createSelectedFeatureText = (): void => {
    const style = new PIXI.TextStyle({
      fill: "#ffffff",
      fontFamily: "Tahoma",
      fontSize: 35,
      lineJoin: "round",
      miterLimit: 5,
    });

    this.FeatureSelectedText = new PIXI.Text("nothing selected", style);
    this.FeatureSelectedText.anchor.set(0, 0.5);
    this.FeatureSelectedText.x = 30;
    this.FeatureSelectedText.y = this.activeGameData.size[1] - 100;
    this.FeatureSelectedText.rotation = -(Math.PI / 2);
    this.parentFeatureListClosed.addChild(this.FeatureSelectedText);
  };

  public getVisible = (): boolean => {
    return this.parentFeatureListOpen.alpha > 0;
  };
  public setVisible = (bool: boolean): void => {
    this.hideTheInstructions(!bool);
    this.parentFeatureListOpen.alpha = bool ? 1 : 0;
    this.enableBtns(bool);

    // this.FeatureSelectedText.alpha = !bool ? 1 : 0;
    // this.parentFeatureListClosed.alpha = bool ? 0 : 1;
  };

  public enableBtns = (bool: boolean): void => {
    this.bgListOpen.interactive = bool;
    if (this.featureSelectBtns != undefined) {
      this.featureSelectBtns.setClickable(bool);
    }

    this.closeBtn.setLabelClose(bool);
  };
  public setMainToggleRed = (bool: boolean): void => {
    this.bgListClosed.tint = bool ? 0xffffff : 0x000000;

    this.bgListClosed.interactive = bool;
    this.bgListClosed.buttonMode = bool;
  };
  public setInstructionText = (newText: string): void => {
    this.FeatureSelectedText.text = newText;
  };
  public createEmulationFeaturesList = (
    gameFeaturesList: GameRoundMetaData[]
  ): void => {
    this.gameFeaturesList = gameFeaturesList;
    // this.gameFeaturesList;
    this.featureSelectBtns = new EmulationSelectorList(
      this.listFeatureParent,
      this.activeGameData,
      this.gameFeaturesList
    );
    // this.featureSelectBtns;
  };
}
class EmulationModeDataHandler {
  private emulationGameContexts: GameContext[];
  private currentIndex: number = 0;
  private currentGameRound: GamePlayResult;
  private isJackpotContext: JackpotContext;
  private roundId: number;
  private startPlayerBalance: PlayerBalance; //{creditsBalance:{amount:number, currency:string}};

  constructor() {
    //--
  }
  public setGameRounds = (emulationContexts: GamePlayResultsList): void => {
    this.emulationGameContexts = emulationContexts.gameContexts; //copy all the game context to the array
    this.isJackpotContext = undefined;
    if (emulationContexts?.jackpotContext?.jackpotSpinWin !== undefined) {
      this.isJackpotContext = emulationContexts.jackpotContext;
    }
    this.currentIndex = -1; //reset the index to zero when saving  game rounds to array
    this.roundId = emulationContexts.id;
    this.startPlayerBalance = emulationContexts.startPlayerBalance;
    // console.log('active Context: ', this.startPlayerBalance ,emulationContexts);
  };
  public getNext = (): GamePlayResult => {
    if (this.currentIndex < this.emulationGameContexts.length - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0; // Reset the index to zero;
    }
    // console.log('load gameContext: ', this.currentIndex);
    const gameRoundData: GamePlayResult = {
      gameContext: this.emulationGameContexts[this.currentIndex],
      gameRoundId: this.roundId,
      playerBalance: this.startPlayerBalance,
    };

    if (this.isJackpotContext !== undefined) {
      gameRoundData.jackpotContext = this.isJackpotContext;
    }
    this.currentGameRound = gameRoundData;
    // console.log("active Context: ", this.currentGameRound.playerBalance);

    this.currentGameRound = gameRoundData;
    return this.currentGameRound;
  };
  public getCurrentIndex = (): number => {
    return this.currentIndex;
  };
}
